module.exports = __webpack_public_path__ + "static/media/icn_blog_active.b179a303.svg";